import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { SET_LOADING } from '../../data/store/ui/ui.actions';
import { finalize } from 'rxjs/operators';

let requestCount = 0;

export const loaderInterceptor: HttpInterceptorFn = (request, next) => {
  const store = inject(Store);
  requestCount++;
  store.dispatch(SET_LOADING({ uiLoading: { isLoading: true } }));

  return next(request).pipe(
    finalize(() => {
      requestCount--;
      if (requestCount === 0) {
        store.dispatch(SET_LOADING({ uiLoading: { isLoading: false } }));
      }
    })
  );
};
